import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';

export const ChipFiltersContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',

  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  overflow: 'auto',
  width: '100%'
}));

export const ChipFilter = styled(Chip)(({ theme }) => ({
  padding: theme.spacing(0, 1)
}));
